import React, { useRef, useState, useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import FieldLoader from './FieldLoader';
import { FaSearch } from 'react-icons/fa';
import io from 'socket.io-client';
import debounce from 'lodash.debounce';
import { useHistory } from 'react-router-dom';

// Create the socket connection outside the component
// const socket = io(process.env.REACT_APP_API_BASE_SOCKET, { transports: ["websocket"] }); // Replace with your backend URL
const socket = io('https://royalkavery.in', {
    path: '/socket.io',
    transports: ['websocket'],
});
const GlobalFilter = ({
    placeholder,
    label,
    injectClass = '',
    loading,
    value,
    setValue,
    onEnter,
    ml,
    length,
    focus,
    blur,
    autoFocus = false,
    onClose,
}) => {
    const inputElem = useRef(null);
    const [searchResults, setSearchResults] = useState({ users: [], products: [], sellers: [] });
    const history = useHistory();
    const chgValue = (e) => {
        if (typeof setValue === 'function') setValue(e.target.value);
    };

    const focusInput = () => inputElem.current.focus();

    const keyPress = (e) => {
        if (e.key === 'Enter' && onEnter) {
            onEnter();
        }
    };

    const onFocus = (e) => {
        if (focus) focus(e.target.value);
    };

    const onBlur = (e) => {
        if (blur) blur(e.target.value);
    };

    const close = () => {
        if (onClose) onClose();
    };

    const closeFunction = () => {
        setValue('');
        setSearchResults({ users: [], products: [], sellers: [] });
        close();
    };

    // Debounced search to avoid excessive calls
    const sendSearchQuery = debounce((query) => {
        if (query.trim()) {
            socket.emit('searchQuery', query);
        } else {
            setSearchResults({ users: [], products: [], sellers: [] });
        }
    }, 300);

    useEffect(() => {
        sendSearchQuery(value);
        return () => sendSearchQuery.cancel();
    }, [value]);

    // Listen for search results from the server
    useEffect(() => {
        socket.on('searchResults', (results) => {
            setSearchResults(results);
        });

        return () => {
            socket.off('searchResults');
        };
    }, []);

    const directToProduct = (productId) => {
        history.push(`/product/${productId}/view`);
        closeFunction();
    };

    return (
        <div
            className={`relative px-2 py-0.5 ring-white text-white rounded-lg ${
                loading ? 'hover:cursor-wait' : 'hover:cursor-pointer'
            } flex items-center ${injectClass} ${loading ? 'animate-pulse' : ''}`}
            onClick={focusInput}
        >
            <span className="text-white  dark:text-gray-400 text-sm mr-3 whitespace-nowrap">
                {label}
            </span>
            <div className="w-full">
                <input
                    placeholder={placeholder}
                    disabled={loading}
                    autoFocus={autoFocus}
                    ref={inputElem}
                    className={`outline-none  flex-grow text-gray-600 dark:text-white font-medium rounded-lg px-3 py-0.5 focus:text-white bg-transparent w-full ${
                        loading ? 'hover:cursor-wait' : ''
                    }`}
                    type="text"
                    value={value}
                    onChange={chgValue}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    onKeyPress={keyPress}
                    maxLength={ml ? `${length}` : ''}
                />
            </div>
            <span className="w-3 mr-1">
                {value ? <MdClose onClick={closeFunction} /> : <FaSearch />}
            </span>
            {loading && <FieldLoader injectClass="absolute bottom-0 w-[98%] h-[2px] left-1" />}

            {/* Display search results */}
            {(searchResults?.users?.length > 0 ||
                searchResults.products.length > 0 ||
                searchResults?.sellers?.length > 0) && (
                <div className="absolute top-full left-0 w-full bg-white shadow-lg rounded-lg mt-2 z-50">
                    <ul className="max-h-60 overflow-auto p-2">
                        {/* {searchResults.users.length > 0 && (
                            <>
                                <li className="font-bold px-4 py-2 bg-gray-100">Users</li>
                                {searchResults.users.map((user) => (
                                    <li key={user._id} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                        {user.name}
                                    </li>
                                ))}
                            </>
                        )} */}
                        {searchResults.products.length > 0 && (
                            <>
                                <li className="font-bold px-4 py-2 text-primeColor bg-gray-100">
                                    Products
                                </li>
                                {searchResults.products.map((product) => (
                                    <li
                                        key={product._id}
                                        className="px-4 py-2 hover:bg-gray-100 text-black cursor-pointer"
                                        onClick={() => directToProduct(product._id)}
                                    >
                                        {product.productName}
                                        {product?.brandName ? ' / ' : ' '}
                                        {product?.brandName || ''}
                                        {product?.modelName ? ' / ' : ' '}
                                        {product.modelName || ''}
                                    </li>
                                ))}
                            </>
                        )}
                        {/* {searchResults.sellers.length > 0 && (
                            <>
                                <li className="font-bold px-4 py-2 bg-gray-100">Sellers</li>
                                {searchResults.sellers.map((seller) => (
                                    <li key={seller._id} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                        {seller.name}
                                    </li>
                                ))}
                            </>
                        )} */}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default GlobalFilter;
